import { EmailAbusePanel } from "@/components/admin/email-abuse";
import { createFileRoute } from "@tanstack/react-router";
import { messagingRouterZodSchemas } from "@papier/messaging-contracts";

export const Route = createFileRoute("/admin/email-abuse")({
  validateSearch: messagingRouterZodSchemas.listEmailAbuse.partial(),
  component: EmailAbusePage,
});

function EmailAbusePage() {
  const { organizationId, after } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <EmailAbusePanel
      key={organizationId}
      organizationId={organizationId}
      after={after}
      onFilter={(organizationId, after) => void navigate({ search: { organizationId, after } })}
    />
  );
}
